import devFaviconUrl from "./assets/favicons/favicon-dev.png";
import localFaviconUrl from "./assets/favicons/favicon-local.png";
import preprodFaviconUrl from "./assets/favicons/favicon-preprod.png";
import productionFaviconUrl from "./assets/favicons/favicon-production.png";
import { getEnvironmentBranding } from "./config";
import { ROOT_VERSION } from "./generated/rootVersion";

const FAVICON_URLS = {
  dev: devFaviconUrl,
  local: localFaviconUrl,
  preprod: preprodFaviconUrl,
  production: productionFaviconUrl,
};

export const environmentFaviconUrl = branding =>
  `${FAVICON_URLS[branding.name] || productionFaviconUrl}?v=${ROOT_VERSION}`;

export const applyEnvironmentFavicon = ({
  branding = getEnvironmentBranding(),
  documentObject = typeof document === "undefined" ? null : document,
} = {}) => {
  if (!documentObject) return null;

  const favicon =
    documentObject.querySelector("link[rel~='icon']") ||
    documentObject.createElement("link");
  favicon.id = "favicon";
  favicon.rel = "icon";
  favicon.sizes = "64x64";
  favicon.type = "image/png";
  favicon.href = environmentFaviconUrl(branding);

  if (!favicon.parentNode) {
    documentObject.head.append(favicon);
  }

  const themeColor = documentObject.querySelector("meta[name='theme-color']");
  themeColor?.setAttribute("content", branding.faviconColor);

  return favicon;
};
